import React, { Component } from "react";
import Pagination from "react-js-pagination";
 
class PaginationImpl extends Component {
  constructor(props) {
    super(props);
    this.state= {
      totalRecords: 0, activePage: 1,
      limit: 10
    };
  }

  //Handle total records if comes
  componentDidMount= (nextProps)=> {
    this.setState({
      totalRecords: nextProps? nextProps.totalRecords: this.props.totalRecords,
    });
  }
 
  //Handle Page Change
  handlePageChange= (page)=> {
    this.setState({
      activePage: page
    });
    this.props.getAllData(page);
  }

  componentWillReceiveProps= (nextProps)=> {
    this.componentDidMount(nextProps);
  }
 
  //Return pagination UI
  render() {
    let { activePage, limit, totalRecords }= this.state;
    return (
      <div className="pagination-wrapper">
        <div className="dataTables_paginate paging_full_numbers" id="advertiser-details_paginate">
          <Pagination
            prevPageText='Prev'
            nextPageText='Next'
            firstPageText='First'
            lastPageText='Last'
            activePage={activePage}
            itemsCountPerPage={limit}            
            totalItemsCount={totalRecords}
            onChange={this.handlePageChange}
          />
        </div>
      </div>
    );
  }
}

export default PaginationImpl;


// WEBPACK FOOTER //
// ./web/components/common/Pagination.jsx